export function debounce(func, wait) {
	let currentTimeout = null;
	return (...args) => {
		if (currentTimeout) {
			clearTimeout(currentTimeout);
		}
		currentTimeout = setTimeout(func, wait || 250, ...args);
	};
}
